module.exports = __webpack_public_path__ + "img/description.ff5d2deb.svg";